import { type ReactElement } from 'react';
import { Close as CloseIcon } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';

interface DeleteSectionDialogProps {
  open: boolean;
  sectionName: string;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteSectionDialog({
  open,
  sectionName,
  isDeleting,
  onClose,
  onConfirm,
}: DeleteSectionDialogProps): ReactElement {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle className="vtwo:flex vtwo:items-center vtwo:justify-between vtwo:font-bold">
        Delete section
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="vtwo:text-typography-primary">
          Deleting the “{sectionName}” section removes it from the website preview straight away and
          cannot be undone.
          <br />
          To make this change permanent on the live website, you need to publish it.
        </DialogContentText>
      </DialogContent>
      <DialogActions className="vtwo:px-6 vtwo:pb-6 vtwo:gap-3">
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={isDeleting}
          className="vtwo:flex-1 vtwo:text-typography-primary vtwo:border-plus-border"
          sx={{ borderRadius: '8px' }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={isDeleting}
          className="vtwo:flex-1"
          sx={{ borderRadius: '8px' }}
        >
          Yes, delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
